import { VKAuthButton } from './VKAuthButton';
import { UpdateType } from '../../utils/const';

export class VKAuthButtons {
  constructor(containers, vkAuthModel) {
    this._containers = containers;
    this._model = vkAuthModel;
    this._buttonsPresenter = new Map();

    this._clickAuthFormButton = this._clickAuthFormButton.bind(this);
    this._handleModelEvent = this._handleModelEvent.bind(this);
  }

  init() {
    this._model.addObserver(this._handleModelEvent);
  }

  _handleModelEvent(updateType, update) {
    switch (updateType) {
      case UpdateType.INIT:
        this._renderButtons(update);
        break;
      case UpdateType.AUTH:
        this._removeButtons();
        this._renderButtons(update);
        break;
      case UpdateType.CONNECT:
        this._removeButtons();
        break;
    }
  }

  _clickAuthFormButton() {
    this._model.clickButton(UpdateType.CLICK);
  }

  _renderButton(container, data, isAuth, action, id) {
    const button = new VKAuthButton(container, data, isAuth, action);
    button.init();
    this._buttonsPresenter.set(id, button);
  }

  _renderButtons(isAuth) {
    this._containers.forEach((field, i) => {
      field && this._renderButton(field, this._model.data, isAuth, this._clickAuthFormButton, i);
    });
  }

  _removeButtons() {
    this._buttonsPresenter.forEach((presenter) => presenter.unrender());
    this._buttonsPresenter.clear();
  }
}
